import React, { useRef } from "react";
import { useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import 'animate.css'

// Componentes
import Navbar from "../navigation/navbar";
import Footer from "../navigation/footer";
import Contacto from "../navigation/footercontact";
// Imagenes
import fondo from "../../assets/images/fondo.png";
import L1 from "../../assets/images/L1.png";
const LandingPage = () => {
  useEffect(() => {
    // Esto hará que el scroll vuelva al inicio al montar el componente
    window.scrollTo(0, 0);
}, []); // Dependencia vacía para que se ejecute solo una vez cuando el componente se monta

  const navigate = useNavigate();

  // Crear una referencia para la siguiente sección
  const siguienteSeccionRef = useRef(null);

  // Función para desplazarse a la siguiente sección
  const scrollToNextSection = () => {
      siguienteSeccionRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  const goToSection = (section) => {
      navigate('/servicios', { state: { section } });
  };

  const pageTransition = {
    // initial: { opacity: 0, x: 100 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
    transition: { duration: 1 }
  };



  return (
    <motion.div className="w-full" initial="initial"
    animate="animate"
    exit="exit"
    variants={pageTransition}>
      {/* navbar  */}
      <div className="container mx-auto">
        <Navbar />
      </div>

      {/* Hero */}
      <div className="relative md:h-screen">
        <img
          className="absolute object-cover w-full h-full"
          src={fondo}
          alt="Fondo Landing Page"
        />

        <div className="container relative h-full pt-24 mx-auto ">
          <div className="flex flex-col items-center justify-center h-full text-center lg:w-2/3 lg:text-left lg:items-start p-14">
            <h1 className="text-xl font-bold text-white md:text-3xl lg:text-5xl">
            Garantizando la Seguridad y Calidad de tus Equipos con Tecnología de Punta
            </h1>
            <p className="my-2 text-base text-white md:text-xl lg:text-2xl lg:py-4">
            Innovando en seguridad y confiabilidad industrial desde 2008, con soluciones técnicas que protegen lo esencial.
            </p>
            <button onClick={scrollToNextSection} className="px-4 py-2 mt-4 text-base font-bold text-white border-2 border-white rounded md:text-xl lg:text-2xl hover:bg-white hover:text-darkblue">
              Descubre más
            </button>
          </div>
        </div>
      </div>

      {/* Qué es SEPROA */}
      <div className="flex items-center justify-center w-full bg-white p-14">
        <div className="container flex flex-col items-center justify-center mx-auto lg:flex-row">
          {/* Texto  */}
          <div className="lg:w-1/2">
            <h2 className="py-4 text-2xl font-bold text-darkblue md:text-3xl lg:text-4xl">
            ¿Qué es NDT Technical Solutions?
            </h2>
            <p className="text-lg leading-7 text-justify md:text-justify md:leading-8 lg:leading-9 md:text-xl lg:text-2xl">
            NDT Technical Solutions CR S.A. es una empresa líder en soluciones de inspección y evaluación no destructiva con sede en Costa Rica. Desde su fundación en 2008, hemos impulsado la seguridad y la calidad en una amplia variedad de industrias, incluyendo la aeronáutica, la automotriz, la construcción, la energía y más. Nuestro enfoque se centra en utilizar tecnología avanzada y métodos innovadores para garantizar que los equipos y componentes industriales se mantengan en condiciones óptimas y seguras.
            </p>
          </div>
          <div className="flex items-center justify-center w-full py-12 animate__animated animate__fadeIn lg:py-8 lg:w-1/2">
            <img src={L1} alt="Imagen de referencia" />
          </div>
        </div>
      </div>

      {/* Servicios  */}
      <div ref={siguienteSeccionRef} className="flex items-center justify-center w-full bg-darkgray p-14">
        <div className="container flex flex-col items-center justify-center mx-auto ">
          {/* textos  */}
          <div className="max-w-4xl text-center">
            <h2 className="py-4 text-2xl font-bold text-white md:text-3xl lg:text-4xl">
              Nuestros Servicios
            </h2>
            <p className="text-lg font-light text-center text-white md:text-xl lg:text-2xl">
            Nos dedicamos a ofrecer una gama completa de servicios de inspección y pruebas no destructivas (NDT) para garantizar la seguridad y el funcionamiento óptimo de los equipos y estructuras en diversas industrias. Nuestra experiencia abarca sectores como la aeronáutica, la construcción, la automotriz, la ferroviaria, la marítima, la energética, entre otros.
            </p>
          </div>
          {/* Cards  */}
          {/* Botón para más información */}
          <div className="flex justify-center w-full">
            <Link to="/servicios">
            <button  className="px-4 py-2 mt-8 text-base font-bold text-white duration-200 border-gray-500 rounded shadow-md bg-gradient-to-r from-lightblue to-lightblue2 hover:scale-105 md:text-xl lg:text-2xl">
              Descubre más
            </button>
            </Link>
          </div>
        </div>
      </div>

      {/* Datos relevantes */}
      <div className="flex items-center justify-center w-full bg-white py-14">
        <div className="container flex flex-col items-center justify-center mx-auto ">
          <h2 className="py-4 text-2xl font-bold md:text-3xl lg:text-4xl">
            Datos Relevantes
          </h2>
          {/* datos  */}
          <div className="grid w-full grid-cols-1 gap-8 gap-y-12 place-items-center justify-items-center md:grid-cols-2 lg:grid-cols-2">
            {/* dato 1 */}
            <div className="flex flex-col items-center justify-center max-w-lg px-8 space-y-2 text-center">
              <h3 className="text-4xl font-black text-lightblue md:text-5xl lg:text-6xl">
                +15
              </h3>
              <p className="text-lg font-bold md:text-xl lg:text-2xl">
                Años de experiencia
              </p>
              <p className="text-base font-normal md:text-lg lg:text-xl">
              en pruebas e inspecciones no destructivas, respaldando la seguridad y calidad en diversas industrias a nivel nacional e internacional.
              </p>
            </div>

            {/* dato 2 */}
            <div className="flex flex-col items-center justify-center max-w-lg px-8 space-y-2 text-center">
              <h3 className="text-4xl font-black text-lightblue md:text-5xl lg:text-6xl">
                1era
              </h3>
              <p className="text-lg font-bold md:text-xl lg:text-2xl">
                empresa proveedora
              </p>
              <p className="text-base font-normal md:text-lg lg:text-xl">
                en servicios especializados en NDT para sectores como aeronáutica, construcción, automotriz y otros, con un enfoque integral en inspecciones y mantenimiento.
              </p>
            </div>

            {/* dato 3 */}
            <div className="flex flex-col items-center justify-center max-w-lg px-8 space-y-2 text-center">
              <h3 className="text-4xl font-black text-lightblue md:text-5xl lg:text-6xl">
                ASNT
              </h3>
              <p className="text-lg font-bold md:text-xl lg:text-2xl">
              afiliados a
              </p>
              <p className="text-base font-normal md:text-lg lg:text-xl">
              <i>The American Society for Nondestructive Testing</i>, garantizando estándares internacionales de calidad y capacitación.
              </p>
            </div>

            {/* dato 4 */}
            <div className="flex flex-col items-center justify-center max-w-lg px-8 space-y-2 text-center">
              <h3 className="text-4xl font-black text-lightblue md:text-5xl lg:text-6xl">
                Calidad en
              </h3>
              <p className="text-lg font-bold md:text-xl lg:text-2xl">
              Servicios de alta tecnología
              </p>
              <p className="text-base font-normal md:text-lg lg:text-xl">
              con equipos portátiles y técnicos calificados en técnicas avanzadas como rayos X, ultrasonido, partículas magnéticas y más, para una cobertura eficiente y confiable.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Contacto */}
      <div className="">
        <Contacto />
      </div>

      {/* Footer */}
      <div className="">
        <Footer />
      </div>
    </motion.div>
  );
};

export default LandingPage;
